// extracted by mini-css-extract-plugin
module.exports = {"container":"SurveyResultsContainer_container__3G-hk","wrapper":"SurveyResultsContainer_wrapper__ZOvHw","title":"SurveyResultsContainer_title__1C0M5"};